export const COMMON_DATETIME_FORMAT = "MM/DD/YYYY HH:mm";
export const LONG_DATETIME_FORMAT = "MM/DD/YYYY HH:mm:ss";
export const SHORT_DATETIME_FORMAT = "MM/DD/YYYY";
